import Header from './components/Header';
import Hero from './components/Hero';
import SectionAbout from './components/SectionAbout';
import SectionCards from './components/SectionCards';
import SectionIndex from './components/SectionIndex';
import SectionContact from './components/SectionContact';
import SectionTopics from './components/SectionTopics';
import SectionComments from './components/SectionComments';
import SectionFAQ from './components/SectionFAQ';
import SectionMedia from './components/SectionMedia';
import SectionApp from './components/SectionApp';
import SectionRanking from './components/SectionRanking';
import SectionCarousel from './components/SectionCarousel';
import SectionFeatures from './components/SectionFeatures';
import SectionUpdates from './components/SectionUpdates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionAbout />
        <SectionCards />
        <SectionIndex />
        <SectionContact />
        <SectionTopics />
        <SectionComments />
        <SectionFAQ />
        <SectionMedia />
        <SectionApp />
        <SectionRanking />
        <SectionCarousel />
        <SectionFeatures />
        <SectionUpdates />
      </main>
      <Footer />
    </div>
  );
}